module.exports = __webpack_public_path__ + "img/mission.ce2a443b.jpg";